import { render, staticRenderFns } from "./StationsTable.vue?vue&type=template&id=22ca21f2"
import script from "./StationsTable.vue?vue&type=script&lang=js"
export * from "./StationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports